// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607011412/js/" + chunkId + "." + {"44":"48f6bccc","225":"eb451328","481":"7cc721e1","486":"ab4712b6","770":"b0b07dc2"}[chunkId] + ".0.4283895437419386.chunk.js";
};